import React from 'react';
import {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import { Auth, API, graphqlOperation } from 'aws-amplify';
import { Storage } from 'aws-amplify';

import CallToActionCard from './CallToActionCard'

import { listCallToActionCards } from '../../graphql/queries'
import { updateCallToActionCard } from '../../graphql/mutations'

function CallToActionCards({updateContentState}) {


  const [cards, setCards] = useState('');

  useEffect(() => {
    fetchCards()
  }, []);

  function dateToString(date){
    if(date!==undefined)
      return 'Updated on '+ date.split('T')[0]
    return ''
  }

  async function cardLiked(id, likes){
    var updateDetails = {
      id: id,
      likes: likes+1
    }
    await API.graphql({ query: updateCallToActionCard, variables: {input: updateDetails}});
    fetchCards()
  }

  async function fetchCards(){
    const cards = await API.graphql(graphqlOperation(listCallToActionCards));
    const cardList = cards.data.listCallToActionCards.items
    for(var card of cardList){
      card.videoContent = await Storage.get('videos/'+card.videoContent,
        { level: 'public', download: false, cacheControl: 'no-cache', contentType: 'video/mp4' })
    }
    setCards(cardList.map((item) => {
      return (
        <CallToActionCard
          key={item.id}
          id={item.id}
          title={item.title}
          textContent={item.textContent}
          mediaContent={item.videoContent}
          likes={item.likes}
          state={item.state}
          updateContentState={updateContentState}
          lastUpdated={dateToString(item.updatedOn)}
          cardLiked={cardLiked}
        />
      );
    }))
  }

  return (
    <div className="grid xl:grid-cols-2 gap-6">
      {cards!==''?cards:''}
    </div>
  );
}

export default CallToActionCards;